module.exports = __webpack_public_path__ + "img/map-icon.6824bd1d.png";